import copy from 'copy-text-to-clipboard'
import { Controller } from '@hotwired/stimulus'
import { useEmitter } from '@/emitter'

export default class extends Controller {
    connect() {
        useEmitter(this)
    }
    
    copy({ params: { text }}) {
        copy(text)

        this.$emit('toastify', {
            text: 'Ссылка добавлена в буфер обмена',
            type: 'info', 
            duration: 5000 
        })
    }
}